import React from 'react'
import { useLocation } from "react-router-dom";
import Header from './Header';
import ScrollToTop from './const';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default Layout